import React, { useReducer } from 'react';
import clienteAxios from '../../config/axios';
import tokenAuth from '../../config/token';
import DescargasContext from './descargasContext';
import DescargasReducer from './descargasReducer';

import 
{
    SPINNER_ON,
    SPINNER_OFF,
    DESCARGAS_ERROR,
    DESCARGAS_BASEUNIVERSOPROSPECTOSSECTORCLIENTE,
    DESCARGAS_NOMBREBASEUNIVERSOPROSPECTOSSECTORCLIENTE
}
from '../../types';

const DescargasState = props => {
    const initialState = {
        nombreBaseUniversoProspectosSectorCliente: [],
        baseUniversoProspectosSectorCliente: [],
        mensaje: null,
        loadingSpinner: false
    }
    
    const [state, dispatch] = useReducer(DescargasReducer, initialState);


    const fnDescargasBaseUniversoProspectosSectorCliente = async (datos) => {
        const token = localStorage.getItem('token');
        if(token){
            //Envia el Token por Headers
            tokenAuth(token);
            //console.log('token fnDescargasBaseUniversoProspectosSectorCliente');
        }

        //console.log('fnDescargasBaseUniversoProspectosSectorCliente');
        try {

            dispatch({
                type: SPINNER_ON
            });

            const respuesta = await clienteAxios.post('/api/descargas/descargasBaseUniversoProspectosSectorCliente', datos);
            //console.log(respuesta.data.recordsets[1]);
            
            dispatch({
                type: DESCARGAS_NOMBREBASEUNIVERSOPROSPECTOSSECTORCLIENTE,
                payload: respuesta.data.recordsets[0][0].nombreArchivo
            });

            dispatch({
                type: DESCARGAS_BASEUNIVERSOPROSPECTOSSECTORCLIENTE,
                payload: respuesta.data.recordsets[1]
            });

            dispatch({
                type: SPINNER_OFF
            });
            
        } catch (error) {
            console.log(error);
            dispatch({
                type: DESCARGAS_ERROR
            });

            dispatch({
                type: SPINNER_OFF
            }); 
        }
    }


    return (
        <DescargasContext.Provider
            value= {{
                baseUniversoProspectosSectorCliente: state.baseUniversoProspectosSectorCliente,
                nombreBaseUniversoProspectosSectorCliente: state.nombreBaseUniversoProspectosSectorCliente,
                fnDescargasBaseUniversoProspectosSectorCliente: fnDescargasBaseUniversoProspectosSectorCliente,
                
            }}
        >
            {props.children}
        </DescargasContext.Provider>
    )
}

export default DescargasState;